import axios from "axios";

export default {
  namespaced: true,
  state: {
    investjournals: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    investjournalsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    CLEAR_INVESTJOURNALS(state) {
      state.investjournals = [];
    },
    RECEIVED_INVESTJOURNALS(state, payload) {
      state.investjournals = payload;
      state.isReceiving = false;
    },
    RECEIVED_INVESTJOURNAL(state, payload) {
      let find = state.investjournals.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { investjournals: [payload, ...state.investjournals] });
      }
      else {
        let index = state.investjournals.findIndex(x => x._id === payload._id);
        state.investjournals.splice(index, 1, payload);
      }
    },
    RECEIVING_INVESTJOURNALS(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },

    RECEIVING_INVESTJOURNAL(state) {
      state.isReceiving = true;
    },
    UPDATED_INVESTJOURNAL(state, payload) {
      let index = state.investjournals.findIndex(investjournal => investjournal._id === payload._id);
      state = Object.assign(state, {
        investjournals: state.investjournals.map((investjournal, i) => {
          if (i === index) {
            return Object.assign({}, investjournal, payload);
          }
          return investjournal;
        }),
        isUpdating: false,
        investjournalsMessage: 'InvestJournals has been updating!',
      })
    },
    UPDATING_INVESTJOURNAL(state) {
      state.isUpdating = true;
    },
    DELETED_INVESTJOURNAL(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.investjournals.findIndex(investjournal => investjournal._id === payload._id);
      console.log(indexToDelete);
      let investjournals = [...state.investjournals];
      investjournals.splice(indexToDelete, 1);
      state = Object.assign(state, {
        investjournals: [...investjournals],
        isDeleting: false,
        idToDelete: null,
        investjournalsMessage: 'InvestJournal has been Deleted!',
      });
    },
    DELETING_INVESTJOURNAL(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteInvestJournalRequest({dispatch}, payload) {
      dispatch("deletingInvestJournal", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/investjournal/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteInvestJournal", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteJournalTransactionRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/delete/investtransaction/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){return null}
    },
    async insertInvestJournalRequest({dispatch}, payload) {
      try {
        dispatch("receivingInvestJournals");
        var token = localStorage.getItem('token');
        let url = 'https://api.accountxc.com:3100/insert/investjournal';
        let data = payload;
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        console.log('here2', data);
        let response = await axios({method: "post", url: url, headers: headers, data: data});
        await dispatch("receiveInvestJournal", response.data);
        return response.data;
      } catch (error) {
        console.log(error.data);
      }

    },
    async insertJournalTransactionRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.accountxc.com:3100/insert/investtransaction/" + payload.id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async getInvestJournalRequest({dispatch}, id) {
      dispatch("receivingInvestJournals");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/investjournal/' + id;
      console.log(url)
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "get",url: url,headers: header});
      dispatch("receiveInvestJournal", response.data);
      return response.data;
    },
    async getInvestJournalsRequest({dispatch}) {
      dispatch("receivingInvestJournals");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/investjournals';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        dispatch("receiveInvestJournals", response.data);
      })
    },
    async findInvestJournalsRequest({dispatch}, payload) {
      try{
        dispatch("receivingInvestJournals");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/investjournals';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveInvestJournals", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateInvestJournalRequest({dispatch}, payload) {
      dispatch("updatingInvestJournal");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/investjournal/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateInvestJournal", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateJournalTransactionRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/investtransaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    clearInvestJournals({commit}) {
      commit("CLEAR_INVESTJOURNALS")
    },
    receiveInvestJournals({commit}, payload) {
      commit("RECEIVED_INVESTJOURNALS", payload)
    },
    receiveInvestJournal({commit}, payload) {
      commit("RECEIVED_INVESTJOURNAL", payload)
    },
    receivingInvestJournals({commit}) {
      commit("RECEIVING_INVESTJOURNALS")
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },

    receivingInvestJournal({commit}) {
      commit("RECEIVING_INVESTJOURNAL")
    },
    updateInvestJournal({commit}, payload) {
      commit("UPDATED_INVESTJOURNAL", payload)
    },
    updatingInvestJournal({commit}) {
      commit("UPDATING_INVESTJOURNAL")
    },
    deleteInvestJournal({commit}, payload) {
      commit("DELETED_INVESTJOURNAL", payload)
    },
    deletingInvestJournal({commit}, payload) {
      commit("DELETING_INVESTJOURNAL", payload)
    }
  },
};
